export const countCharactersExcludingSpaces = (htmlString) => {
    if (!htmlString || typeof htmlString !== 'string') {
        return 0;
    }

    try {
        // Remove HTML tags
        const withoutTags = htmlString.replace(/<\/?[^>]+(>|$)/g, '');

        // Remove HTML comments
        const withoutComments = withoutTags.replace(/<!--[\s\S]*?-->/g, '');

        // Remove ALL whitespace and count remaining characters
        const cleanText = withoutComments.replace(/\s+/g, '');

        return cleanText.length;
    } catch (error) {
        console.error('Error counting characters:', error);
        return 0;
    }
};

export const minifyHtml = (html) => {
    return html
        .replace(/\n/g, ' ') // Remove newlines
        .replace(/\s+/g, ' ') // Collapse multiple spaces
        .replace(/>\s+</g, '><') // Remove spaces between tags
        .trim();
};